/**
 * Validates discount amount/percentage against a base price (MRP, original, or regular).
 * @returns {string|null} Error message or null if valid / empty
 */
export function getDiscountValidationError(discount, basePrice, options = {}) {
    const base = Number(basePrice) || 0;
    const baseLabel = options.baseLabel ?? "MRP";
    if (!base) return null;

    const type = discount?.discount_type || "price";

    if (type === "percentage") {
        const raw = discount.discount_percentage;
        if (raw === "" || raw == null) return null;
        const pct = Number(raw);
        if (!Number.isFinite(pct)) return null;
        if (pct > 100) return "Discount percentage cannot exceed 100%.";
        if (pct < 0) return "Discount percentage cannot be negative.";
        return null;
    }

    const raw = discount.discount_price;
    if (raw === "" || raw == null) return null;
    const amount = Number(raw);
    if (!Number.isFinite(amount)) return null;
    if (amount > base) return `Discount cannot be greater than ${baseLabel}.`;
    if (amount < 0) return "Discount cannot be negative.";
    return null;
}
